export default __webpack_public_path__ + "static/media/Optimized-pexels-shvets-production-7203724.555830b4.jpg";